<template>
  <span
    v-tooltip="statusDetails.tooltip !== statusDetails.label ? { content: statusDetails.tooltip, placement: 'top', offset: 8, classes: 'tooltip--new' } : null"
    class="lead-flow-socket-status ui-connection-status ui-tooltip-target"
    :tabindex="statusDetails.tooltip !== statusDetails.label ? 0 : null"
    :class="[`lead-flow-socket-status--${status}`, `ui-connection-status--${status}`]"
    :aria-label="statusDetails.tooltip"
  >
    <span aria-hidden="true"></span>
    {{ statusDetails.label }}
  </span>
</template>

<script>
const STATUS_DETAILS = {
  connected: {
    label: 'Live',
    tooltip: 'Live updates connected'
  },
  reconnecting: {
    label: 'Reconnecting',
    tooltip: 'Reconnecting'
  },
  unavailable: {
    label: 'REST',
    tooltip: 'Live updates unavailable · REST mode'
  }
}

export default {
  name: 'LeadFlowSocketStatus',
  props: {
    status: {
      type: String,
      default: 'unavailable',
      validator: status => Object.keys(STATUS_DETAILS).includes(status)
    }
  },
  computed: {
    statusDetails() {
      return STATUS_DETAILS[this.status]
    }
  }
}
</script>
